import { render, staticRenderFns } from "./MonthHistoryList.vue?vue&type=template&id=0478a572&"
import script from "./MonthHistoryList.vue?vue&type=script&lang=js&"
export * from "./MonthHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports